import type { ReactElement } from 'react'

import { NewsArticle } from './NewsArticle'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { NewsRelease } from '@/types/newsRelease'

type Props = {
  news: NewsRelease
}

export const NewsArticlePage = ({ news }: Props) => {
  return <NewsArticle {...news} />
}

NewsArticlePage.getLayout = function getLayout(page: ReactElement<Props>) {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const { _id, title, utilMeta } = page.props.news

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news/' },
    { name: 'ニュースリリース', path: '/news/release' },
    { name: title, path: '' },
  ]

  return (
    <>
      <Head
        title={title}
        description={utilMeta?.blogUtilMeta.description || ''}
        ogp={{
          type: 'article',
          url: `news/release/${_id}`,
        }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}
